import React from "react";
import { BookingLanguage } from "@/types/booking";
import { useIsMobile } from "@/hooks/use-mobile";
import { getTranslations } from "./ClinicStepTranslations";

interface HeaderProps {
  language: BookingLanguage;
}

export const Header = ({ language }: HeaderProps) => {
  const t = getTranslations(language);

  return (
    <div className="text-center mb-6 lg:mb-8 px-4 hidden lg:block">
      <h1
        className="mb-2"
        style={{
          fontWeight: 400,
          color: "#2D2D2D",
          fontSize: 24,
        }}
      >
        {t.title}
      </h1>
      <p
        className="mx-auto leading-relaxed"
        style={{ fontSize: 14, fontWeight: 400, color: "#2D2D2D" }}
      >
        {t.subtitle}
      </p>
    </div>
  );
};
